import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessRightDirective } from './access-rights.directive';

@NgModule({
  declarations: [AccessRightDirective],
  imports: [CommonModule],
  exports: [AccessRightDirective],
})
export class AccessRightModule {}
